import React from "react";
import PropTypes from "prop-types";

import { Hotspot, Markdown, Marker } from "../components";
import { Paragraph } from "../styleguide";

const MediaContainer = ({
    image,
    video,
    alt,
    caption,
    hotspots,
    markers,
    activePanel,
    onHotspotClick,
    total,
    index,
    active,
}) => (
    <div style={{ opacity: active ? 1 : 0.5 }}>
        <div
            style={{
                position: "relative",
                overflow: "hidden",
                paddingTop: "56.25%",
                border: "1px solid #f0f1f2",
            }}
            className="media-container-content"
        >
            {image && (
                <img
                    src={image}
                    alt={alt}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        border: 0,
                        width: "100%",
                        height: "100%",
                    }}
                />
            )}

            {hotspots &&
                hotspots.map(({ headline, posX, posY }) => (
                    <Hotspot
                        key={headline}
                        active={headline === activePanel}
                        onHotspotClick={() => onHotspotClick(headline === activePanel ? "" : headline)}
                        posX={posX}
                        posY={posY}
                    />
                ))}

            {markers && markers.map((marker, index) => <Marker key={index} {...marker} />)}

            {video && (
                <video
                    title={alt}
                    src={video}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        border: 0,
                        width: "100%",
                        height: "100%",
                    }}
                    controls
                    controlsList="nodownload"
                />
            )}
        </div>
        <div style={{ display: "flex", margin: "16px 0" }}>
            <div style={{ color: "#e40045", fontWeight: "bold", marginRight: 24 }}>
                {index + 1}/{total}
            </div>
            {caption && (
                <Markdown
                    source={caption}
                    renderers={{
                        paragraph: (props) => <Paragraph>{props.children}</Paragraph>,
                    }}
                />
            )}
        </div>
    </div>
);

MediaContainer.propTypes = {
    image: PropTypes.string,
    video: PropTypes.string,
    alt: PropTypes.string,
    caption: PropTypes.string,
    hotspots: PropTypes.arrayOf(PropTypes.object),
    markers: PropTypes.arrayOf(PropTypes.object),
    activePanel: PropTypes.string,
    onHotspotClick: PropTypes.func,
};

export default MediaContainer;



// WEBPACK FOOTER //
// ./src/emobility/EMobilitySlide.js